import type {$Fetch} from "nitropack";

export interface RegisterBody {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    role: string;
    /** Optional referral attribution token (the `ref` param from an invite link). */
    ref?: string;
}
export interface AllowedUrlParams {
    redirect_to: string,
}

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface ChangePasswordRequest {
    current_password: string;
    new_password: string;
}

export interface OAuthCallbackRequest {
    provider: string;
    access_token: string;
    is_organization?: boolean;
}

export interface OAuthCallbackResponse {
    is_new_user: boolean;
    [key: string]: unknown;
}

function formatParams(params: AllowedUrlParams) {
    const queryParams = new URLSearchParams();
    queryParams.append('redirect_to', params.redirect_to);
    return queryParams.toString();
}

export const AuthRepository = (client: $Fetch) => ({
    createUser: (data: RegisterBody, params?: AllowedUrlParams) => {
        return client(`/v2/auth/sign-up?${params ? formatParams(params) : ''}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        })
    },
    me: (params?: AllowedUrlParams) => {
        return client(`/v2/auth/me?${params ? formatParams(params) : ''}`, {
            method: 'GET',
        })
    },
    logout: () => {
        return client(`/v2/auth/sign-out`, {
            method: 'POST',
        });
    },
    oauthCallback: (data: OAuthCallbackRequest): Promise<OAuthCallbackResponse> => {
        return client(`/v2/auth/oauth/callback`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            }
        })
    },
})